import { StarIcon } from '@heroicons/react/20/solid'
import { CheckCircleIcon } from '@heroicons/react/24/outline'

import { testimonials, type Testimonial } from '@/data/testimonials'

function TestimonialCard({ testimonial }: { testimonial: Testimonial }) {
  return (
    <article className="flex w-72 shrink-0 flex-col rounded-xl border border-blue-100 bg-white p-5 text-left shadow-sm">
      <div className="flex gap-0.5" aria-label="5 out of 5 stars">
        {[...Array(5)].map((_, index) => (
          <StarIcon key={index} className="h-4 w-4 text-yellow-400" aria-hidden="true" />
        ))}
      </div>
      <h3 className="mt-3 text-sm font-semibold text-gray-950">&ldquo;{testimonial.title}&rdquo;</h3>
      <p className="mt-2 flex-1 text-xs leading-5 text-gray-600">{testimonial.body}</p>
      <div className="mt-4 flex items-center gap-3 border-t border-gray-100 pt-3">
        <div className="flex h-8 w-8 shrink-0 items-center justify-center overflow-hidden rounded-full bg-blue-100 text-xs font-semibold text-blue-700">
          {testimonial.image ? (
            <img className="h-full w-full object-cover" src={testimonial.image} alt="" />
          ) : (
            testimonial.name.charAt(0)
          )}
        </div>
        <div>
          <p className="text-xs font-semibold text-gray-900">{testimonial.name}</p>
          <div className="mt-0.5 flex items-center gap-1 text-gray-400">
            <CheckCircleIcon className="h-3.5 w-3.5" aria-hidden="true" />
            <span className="text-[11px]">Verified Purchase</span>
          </div>
        </div>
      </div>
    </article>
  )
}

export default function PricingTestimonialsMarquee() {
  return (
    <div
      className="mt-7 overflow-hidden pt-1"
      style={{
        maskImage: 'linear-gradient(to right, transparent, black 8%, black 92%, transparent)',
        WebkitMaskImage: 'linear-gradient(to right, transparent, black 8%, black 92%, transparent)',
      }}
      aria-label="Customer testimonials"
    >
      <div className="testimonial-marquee-track flex w-max hover:[animation-play-state:paused]">
        {[0, 1].map((groupIndex) => (
          <div
            key={groupIndex}
            className="flex gap-4 pr-4"
            aria-hidden={groupIndex === 1}
          >
            {testimonials.map((testimonial) => (
              <TestimonialCard key={`${groupIndex}-${testimonial.name}`} testimonial={testimonial} />
            ))}
          </div>
        ))}
      </div>
    </div>
  )
}
